/**
 * Route manifest for the Marketing ▸ Email Campaigns area.
 *
 * The pages themselves live under `src/crm/` (they run on the CRM runtime —
 * crm-api session, CRM Redux store, WebSocket — provided by
 * `MarketingCampaignsRoot`), but the feature was relocated out of `/crm`
 * into `/marketing/campaigns` on 2026-06-02. They are imported via
 * `@crm-src` so they keep the CRM alias/runtime.
 *
 * The routes live HERE rather than inline in `App.tsx` so they can be
 * mounted (and asserted) by `campaignRoutes.test.tsx` — the 2026-06-02 move
 * carried only three of the feature's four routes and silently orphaned the
 * Sendout Logs page for two months. `App.tsx` spreads this manifest under
 * `<Route path="campaigns" element={<MarketingCampaignsRoot />}>`, the same
 * shape `crmRouteElements` uses for `/crm`.
 *
 * Internal links must be built with `emailCampaignsPath` /
 * `emailCampaignEditPath` / `emailCampaignLogsPath`
 * (`@crm-src/lib/email-campaign-routes`) so there is one place to repoint.
 */
import { Route } from "react-router-dom";

import EmailCampaignsPage from "@crm-src/pages/email-campaigns/EmailCampaignsPage";
import EmailCampaignCreatePage from "@crm-src/pages/email-campaigns/create/EmailCampaignsCreatePage";
import EmailCampaignEditPage from "@crm-src/pages/email-campaigns/edit/detail/EmailCampaignsEditDetailPage";
import EmailCampaignLogsPage from "@crm-src/pages/email-campaigns/detail/logs/EmailCampaignsDetailLogsPage";

export const marketingCampaignRouteElements = (
  <>
    <Route index element={<EmailCampaignsPage />} />
    <Route path="create" element={<EmailCampaignCreatePage />} />
    <Route path="edit/:id" element={<EmailCampaignEditPage />} />
    {/* Per-recipient delivery state for one campaign. Reached from the
        "View Sendout Logs" row action on the list (sent / sending only).
        Note the id-first shape — `edit/:id` is the odd one out. */}
    <Route path=":id/logs" element={<EmailCampaignLogsPage />} />
  </>
);
